// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container with dark theme */
.ShortsVideoContent_shortsPageContainer__sj3wC {
  padding: 20px;
  background-color: #121212;
  color: #f5f5f5;
  min-height: 100vh;
}

.ShortsVideoContent_headerSection__ksx4r {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #333;
  padding-bottom: 16px;
}

.ShortsVideoContent_pageTitle__9RfY9 {
  font-size: 28px;
  font-weight: 600;
  color: #ffffff;
}

.ShortsVideoContent_shortsContainer__msuBe {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 30px;
}

.ShortsVideoContent_shortItem__CobhC {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: #1e1e1e;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid #333;
}

.ShortsVideoContent_shortItem__CobhC:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
  border-color: #ff3333;
}

.ShortsVideoContent_hiddenShort__XsVrX {
  opacity: 0.6;
}

.ShortsVideoContent_shortImage__yPtP0 {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.ShortsVideoContent_hiddenBadge__DYMBZ {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(255, 51, 51, 0.8);
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.ShortsVideoContent_shortInfo__mnNOo {
  padding: 16px;
  background-color: #1e1e1e;
  border-top: 1px solid #333;
}

.ShortsVideoContent_shortTitle__byNa\\+ {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 8px 0;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ShortsVideoContent_shortStats__caBES {
  font-size: 13px;
  color: #9e9e9e;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ShortsVideoContent_shortStats__caBES::before {
  content: "•";
  color: #ff3333;
}

.ShortsVideoContent_playButton__VAkyK {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 51, 51, 0.8);
  border-radius: 50%;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease, background-color 0.2s ease;
}

.ShortsVideoContent_shortItem__CobhC:hover .ShortsVideoContent_playButton__VAkyK {
  opacity: 1;
}

.ShortsVideoContent_playButton__VAkyK:hover {
  background-color: rgba(255, 51, 51, 1);
  transform: translate(-50%, -50%) scale(1.1);
}

.ShortsVideoContent_iconsOverlay__7Yb-j {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.ShortsVideoContent_shortItem__CobhC:hover .ShortsVideoContent_iconsOverlay__7Yb-j {
  opacity: 1;
}

.ShortsVideoContent_icon__m1XXz {
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #000000;
}

.ShortsVideoContent_icon__m1XXz:hover {
  background: rgba(255, 255, 255, 1);
}

.ShortsVideoContent_addShortButton__rJIxp {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #ff3333;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.ShortsVideoContent_addShortButton__rJIxp:hover {
  background-color: #ff5252;
  transform: translateY(-2px);
}

.ShortsVideoContent_addShortButton__rJIxp:active {
  transform: translateY(1px);
}

.ShortsVideoContent_loadingState__F9dwq {
  text-align: center;
  padding: 60px;
  color: #9e9e9e;
  font-size: 16px;
  background-color: #1e1e1e;
  border-radius: 8px;
  margin: 40px auto;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  border: 1px solid #333;
}

.ShortsVideoContent_emptyState__hyx\\+h {
  text-align: center;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  background-color: #1e1e1e;
  border-radius: 8px;
  margin: 40px auto;
  max-width: 600px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  border: 1px solid #333;
}

.ShortsVideoContent_emptyState__hyx\\+h p {
  font-size: 18px;
  color: #9e9e9e;
  margin-bottom: 10px;
}

/* Modal styles */
.ShortsVideoContent_modalOverlay__PEzlH {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

.ShortsVideoContent_modalContent__PBBUp {
  background-color: #1e1e1e;
  padding: 28px;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  border: 1px solid #333;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.ShortsVideoContent_modalContent__PBBUp p {
  font-size: 16px;
  color: #f5f5f5;
  margin-bottom: 24px;
}

.ShortsVideoContent_modalButtons__azBi\\+ {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
}

.ShortsVideoContent_modalButton__gZ-vS {
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-size: 15px;
}

.ShortsVideoContent_modalButton__gZ-vS:first-child {
  background-color: #ff3333;
  color: white;
}

.ShortsVideoContent_modalButton__gZ-vS:first-child:hover {
  background-color: #ff5252;
}

.ShortsVideoContent_modalButton__gZ-vS:last-child {
  background-color: #333;
  color: #f5f5f5;
}

.ShortsVideoContent_modalButton__gZ-vS:last-child:hover {
  background-color: #444;
}

.ShortsVideoContent_modalButton__gZ-vS:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Pagination styles */
.ShortsVideoContent_pagination__9LENj {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 40px;
  margin-bottom: 20px;
  padding: 16px;
  background-color: #1e1e1e;
  border-radius: 8px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.ShortsVideoContent_paginationButton__9lrei {
  background-color: #333;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #f5f5f5;
  font-weight: 500;
}

.ShortsVideoContent_paginationButton__9lrei:hover:not(:disabled) {
  background-color: #ff3333;
  color: white;
}

.ShortsVideoContent_paginationButton__9lrei:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ShortsVideoContent_pageInfo__ie1FA {
  color: #9e9e9e;
  font-size: 14px;
}
/*Search Bar*/
.ShortsVideoContent_searchContainer__\\+6g68 {
  display: flex;
  align-items: center;
  background: #f1f1f124;
  padding: 5px 10px;
  border-radius: 6px;
  width: 250px;
}

.ShortsVideoContent_searchIcon__sLGfM {
  color: #666;
}

.ShortsVideoContent_searchInput__e2oao {
  border: none;
  background: transparent;
  padding: 5px;
  outline: none;
  flex: 1 1;
  font-size: 14px;
  color: white;
}
 
@media (max-width: 480px) {
  .ShortsVideoContent_headerSection__ksx4r {
    display: block;
  }
  .ShortsVideoContent_searchContainer__\\+6g68 {
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/ShortsVideoContent.module.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,SAAO;EACP,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Main container with dark theme */\n.shortsPageContainer {\n  padding: 20px;\n  background-color: #121212;\n  color: #f5f5f5;\n  min-height: 100vh;\n}\n\n.headerSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  border-bottom: 1px solid #333;\n  padding-bottom: 16px;\n}\n\n.pageTitle {\n  font-size: 28px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.shortsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 24px;\n  margin-bottom: 30px;\n}\n\n.shortItem {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #1e1e1e;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  border: 1px solid #333;\n}\n\n.shortItem:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);\n  border-color: #ff3333;\n}\n\n.hiddenShort {\n  opacity: 0.6;\n}\n\n.shortImage {\n  width: 100%;\n  height: 260px;\n  object-fit: cover;\n}\n\n.hiddenBadge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: rgba(255, 51, 51, 0.8);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.shortInfo {\n  padding: 16px;\n  background-color: #1e1e1e;\n  border-top: 1px solid #333;\n}\n\n.shortTitle {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 8px 0;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.shortStats {\n  font-size: 13px;\n  color: #9e9e9e;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.shortStats::before {\n  content: \"•\";\n  color: #ff3333;\n}\n\n.playButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(255, 51, 51, 0.8);\n  border-radius: 50%;\n  width: 54px;\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease, background-color 0.2s ease;\n}\n\n.shortItem:hover .playButton {\n  opacity: 1;\n}\n\n.playButton:hover {\n  background-color: rgba(255, 51, 51, 1);\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n.iconsOverlay {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.shortItem:hover .iconsOverlay {\n  opacity: 1;\n}\n\n.icon {\n  background-color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  padding: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #000000;\n}\n\n.icon:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n.addShortButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #ff3333;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 20px;\n  font-weight: 500;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.addShortButton:hover {\n  background-color: #ff5252;\n  transform: translateY(-2px);\n}\n\n.addShortButton:active {\n  transform: translateY(1px);\n}\n\n.loadingState {\n  text-align: center;\n  padding: 60px;\n  color: #9e9e9e;\n  font-size: 16px;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  margin: 40px auto;\n  max-width: 500px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  border: 1px solid #333;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 80px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  margin: 40px auto;\n  max-width: 600px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  border: 1px solid #333;\n}\n\n.emptyState p {\n  font-size: 18px;\n  color: #9e9e9e;\n  margin-bottom: 10px;\n}\n\n/* Modal styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(3px);\n}\n\n.modalContent {\n  background-color: #1e1e1e;\n  padding: 28px;\n  border-radius: 8px;\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n  border: 1px solid #333;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);\n}\n\n.modalContent p {\n  font-size: 16px;\n  color: #f5f5f5;\n  margin-bottom: 24px;\n}\n\n.modalButtons {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.modalButton {\n  padding: 10px 24px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  font-size: 15px;\n}\n\n.modalButton:first-child {\n  background-color: #ff3333;\n  color: white;\n}\n\n.modalButton:first-child:hover {\n  background-color: #ff5252;\n}\n\n.modalButton:last-child {\n  background-color: #333;\n  color: #f5f5f5;\n}\n\n.modalButton:last-child:hover {\n  background-color: #444;\n}\n\n.modalButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Pagination styles */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 40px;\n  margin-bottom: 20px;\n  padding: 16px;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.paginationButton {\n  background-color: #333;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #f5f5f5;\n  font-weight: 500;\n}\n\n.paginationButton:hover:not(:disabled) {\n  background-color: #ff3333;\n  color: white;\n}\n\n.paginationButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pageInfo {\n  color: #9e9e9e;\n  font-size: 14px;\n}\n/*Search Bar*/\n.searchContainer {\n  display: flex;\n  align-items: center;\n  background: #f1f1f124;\n  padding: 5px 10px;\n  border-radius: 6px;\n  width: 250px;\n}\n\n.searchIcon {\n  color: #666;\n}\n\n.searchInput {\n  border: none;\n  background: transparent;\n  padding: 5px;\n  outline: none;\n  flex: 1;\n  font-size: 14px;\n  color: white;\n}\n \n@media (max-width: 480px) {\n  .headerSection {\n    display: block;\n  }\n  .searchContainer {\n    margin-bottom: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shortsPageContainer": `ShortsVideoContent_shortsPageContainer__sj3wC`,
	"headerSection": `ShortsVideoContent_headerSection__ksx4r`,
	"pageTitle": `ShortsVideoContent_pageTitle__9RfY9`,
	"shortsContainer": `ShortsVideoContent_shortsContainer__msuBe`,
	"shortItem": `ShortsVideoContent_shortItem__CobhC`,
	"hiddenShort": `ShortsVideoContent_hiddenShort__XsVrX`,
	"shortImage": `ShortsVideoContent_shortImage__yPtP0`,
	"hiddenBadge": `ShortsVideoContent_hiddenBadge__DYMBZ`,
	"shortInfo": `ShortsVideoContent_shortInfo__mnNOo`,
	"shortTitle": `ShortsVideoContent_shortTitle__byNa+`,
	"shortStats": `ShortsVideoContent_shortStats__caBES`,
	"playButton": `ShortsVideoContent_playButton__VAkyK`,
	"iconsOverlay": `ShortsVideoContent_iconsOverlay__7Yb-j`,
	"icon": `ShortsVideoContent_icon__m1XXz`,
	"addShortButton": `ShortsVideoContent_addShortButton__rJIxp`,
	"loadingState": `ShortsVideoContent_loadingState__F9dwq`,
	"emptyState": `ShortsVideoContent_emptyState__hyx+h`,
	"modalOverlay": `ShortsVideoContent_modalOverlay__PEzlH`,
	"modalContent": `ShortsVideoContent_modalContent__PBBUp`,
	"modalButtons": `ShortsVideoContent_modalButtons__azBi+`,
	"modalButton": `ShortsVideoContent_modalButton__gZ-vS`,
	"pagination": `ShortsVideoContent_pagination__9LENj`,
	"paginationButton": `ShortsVideoContent_paginationButton__9lrei`,
	"pageInfo": `ShortsVideoContent_pageInfo__ie1FA`,
	"searchContainer": `ShortsVideoContent_searchContainer__+6g68`,
	"searchIcon": `ShortsVideoContent_searchIcon__sLGfM`,
	"searchInput": `ShortsVideoContent_searchInput__e2oao`
};
export default ___CSS_LOADER_EXPORT___;
